import { useContext } from 'react';
import {
  ResponsiveContext,
  ResponsiveInitialState
} from '@/contexts/responsive-context';

export const useResponsive = () =>
  useContext(ResponsiveContext) as ResponsiveInitialState;
